export default __webpack_public_path__ + "static/media/p10.9091b8b9.jpeg";